import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, Provider, EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { OverlayHostService } from '../../@core/services/overlay-host/overlay-host.service';
import { SupportRecordingInterceptor } from './support-recording.interceptor';
import { SupportRecordingService } from './support-recording.service';
import { SupportRecComponent } from './support-rec.component';

/**
 * Providers of the browser module; inactive unless phoenix-ui-config.json says `supportRecording.enabled: true`.
 * The ErrorHandler of the app stays as it is — its handleError is wrapped so the recording log sees the error too.
 * Support recording (window and bar) sits in the overlay host next to the router outlet, so it outlives navigation.
 */
export function provideSupportRecording(): Array<Provider | EnvironmentProviders> {
    return [
        { provide: HTTP_INTERCEPTORS, useClass: SupportRecordingInterceptor, multi: true },
        provideAppInitializer(() => {
            const recorder = inject(SupportRecordingService);
            recorder.start();
            if (!recorder.active) return;
            const handler = inject(ErrorHandler);
            const handleError = handler.handleError.bind(handler);
            handler.handleError = (error: unknown) => {
                recorder.recordError(error);
                handleError(error);
            };
            // resolves once the root component exists; the initializer does not wait for it
            void inject(OverlayHostService)
                .getHostView()
                .then(host => host.createComponent(SupportRecComponent))
                .catch((error: unknown) => recorder.recordError(error, 'SupportRec'));
        }),
    ];
}
